import * as PIXI from 'pixi.js'

class NyanSheep {
  constructor (game) {
    this.game = game
    this.speed = 2

    this.textures = {
      sheep1: PIXI.Texture.from('rainbowSheep1'),
      sheep2: PIXI.Texture.from('rainbowSheep2'),
      sheep3: PIXI.Texture.from('rainbowSheep3')
    }

    this.setTextures([
      this.textures.sheep1,
      this.textures.sheep2
    ])
    this.view.animationSpeed = 0.1
    this.view.play()
  }

  setTextures (sprites) {
    if (this.view) {
      this.view.textures = sprites
    } else {
      this.view = new PIXI.extras.AnimatedSprite(sprites)
    }
    this.view.anchor.set(0.5, 0.5)
    this.view.scale.set(0.25)
  }

  draw () {
    this.game.app.stage.addChildAt(this.view, 2)
  }

  setPosition (x, y) {
    this.view.x = x
    this.view.y = y
  }

  moveDown (cameraDelta = 0, entitySpeed = 1, deltaTime = 1) {
    this.view.y += ((this.speed + cameraDelta) * entitySpeed * deltaTime)
  }

  quake () {
    this.setTextures([
      this.textures.sheep3
    ])
  }

  speedUpTo (speed = 2) {
    this.speed = speed
  }
}

export default NyanSheep
